module.exports = __webpack_public_path__ + "static/annual-report-2013-14-4604a6c1d3b10dcd3b8cd8bb389c910b.pdf";